import React from "react";
import styles from "../styles/menus-evento.module.css";

export default function MenusKpis({ kpi }) {
    return (
        <div className={styles.kpis}>
            <div className={styles.kpi}>
                <span className={styles["kpi-title"]}>Eventos</span>
                <span className={styles["kpi-value"]}>{kpi.eventos}</span>
            </div>
            <div className={styles.kpi}>
                <span className={styles["kpi-title"]}>Menús totales</span>
                <span className={styles["kpi-value"]}>{kpi.menusTotales}</span>
            </div>
        </div>
    );
}
